var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99995 1.45312C8.44178 1.45312 8.79995 1.8113 8.79995 2.25313V8.70683L11.2148 6.53349C11.5432 6.23792 12.049 6.26455 12.3446 6.59295C12.6402 6.92136 12.6135 7.42719 12.2851 7.72276L8.53512 11.0978C8.23088 11.3716 7.76902 11.3716 7.46478 11.0978L3.71478 7.72276C3.38637 7.42719 3.35975 6.92136 3.65532 6.59295C3.95088 6.26455 4.45671 6.23792 4.78512 6.53349L7.19995 8.70683V2.25313C7.19995 1.8113 7.55812 1.45312 7.99995 1.45312ZM1.99995 10.5781C2.44178 10.5781 2.79995 10.9363 2.79995 11.3781V12.5031C2.79995 12.8897 3.11335 13.2031 3.49995 13.2031H12.5C12.8866 13.2031 13.2 12.8897 13.2 12.5031V11.3781C13.2 10.9363 13.5581 10.5781 14 10.5781C14.4418 10.5781 14.8 10.9363 14.8 11.3781V12.5031C14.8 13.7734 13.7702 14.8031 12.5 14.8031H3.49995C2.2297 14.8031 1.19995 13.7734 1.19995 12.5031V11.3781C1.19995 10.9363 1.55812 10.5781 1.99995 10.5781Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload2);
export default __webpack_public_path__ + "static/media/iconDownload2.26edcc28cc5a10bde2501196354144cf.svg";
export { ForwardRef as ReactComponent };